import George from '@components/George'

const HomePage = () => {
  return <George />;
};

export default HomePage;
